module.exports = __webpack_public_path__ + "static/media/puzzle-17-bg.481aedf3.svg";